/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-22 13:56:48
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-30 14:14:44
 * @FilePath: \hlweb2.0\src\pages\Solution\Asset\ServiceValue\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";
function SolveProblems() {
  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");
  const solveProblemsInfo = t("solution_asset.asset5", {
    returnObjects: true,
  });
  return (
    <div className="solveProblems_">
      <div className="edition_solution edition_solution_top">
        <div className="edition_solution_title">
          <div>{solveProblemsInfo.title}</div>
          <span>{solveProblemsInfo.detail}</span>
        </div>
      </div>
      <div className="solveProblems_con">
        {solveProblemsInfo.contentList.map((item0, index0) => {
          return (
            <div className="solveProblems_li" key={index0}>
              <div
                className={`solveProblems_li_til ${
                  language === "zh"
                    ? "solveProblems_li_til_zh"
                    : "solveProblems_li_til_en"
                }`}
              >
                <div>{item0.til}</div>
                <div>{item0.til2}</div>
              </div>
              <div className="solveProblems_li_con">{item0.detail}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default SolveProblems;
